<template>
  <div class="view-content">
    <div class="search-box">
      <el-form :model="search" :inline="true" ref="searchFrom" size="small">
        <el-form-item label="用户名称:" prop="searchName">
          <el-input
            v-model="search.searchName"
            placeholder="用户名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" size="small"
            >搜索</el-button
          >
          <el-button @click="clearSearch" size="small">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tools-box">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="handleAdd"
        >新增用户</el-button
      >
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      size="small"
      :header-cell-style="{
        background: '#98b8d9',
        color: '#ffffff',
        fontWeight: 'bold',
        align: 'center',
      }"
    >
      <el-table-column prop="realName" label="真实姓名" align="center">
      </el-table-column>
      <el-table-column prop="phone" label="手机" align="center">
      </el-table-column>
      <el-table-column prop="email" label="邮箱" align="center">
      </el-table-column>
      <el-table-column prop="roleIdstrName" label="角色" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <span
            class="el-icon-edit table-btn btn-default"
            @click="handleEdit(scope.row)"
          >
            编辑
          </span>
          <span
            class="el-icon-delete table-btn btn-danger"
            @click="handleClick(scope.row)"
          >
            删除
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        prev-text="上一页"
        next-text="下一页"
        :current-page.sync="search.pageIndex"
        :page-size.sync="search.pageSize"
        :page-sizes="[10, 30, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="isAdd ? '添加用户' : '修改用户'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form ref="userForm" :model="userForm" label-width="80px" size="small">
        <el-form-item
          label="手机"
          prop="phone"
          :rules="[
            {
              required: true,
              message: '请输入手机',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="userForm.phone" type="phone"></el-input>
        </el-form-item>
        <el-form-item
          label="用户密码"
          prop="password"
          :rules="[
            {
              required: this.isAdd,
              message: '请输入用户密码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model="userForm.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="userForm.realName"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleIds">
          <el-select
            v-model="userForm.roleIds"
            multiple
            placeholder="请选择角色"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in roleList"
              :key="index"
              :label="item.roleName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" type="email"></el-input>
        </el-form-item>
        <!-- <el-form-item label="状态" prop="status">
        <el-radio-group v-model="userForm.status" style="width: 100%">
          <el-radio label="0">禁用</el-radio>
          <el-radio label="1">正常</el-radio>
        </el-radio-group>
       </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" size="small" @click="handleClose"
          >取 消</el-button
        >
        <el-button type="primary" size="small" @click="handleConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { userList, userAdd, userUpdate, userDel } from "@/api/system/user";
import { roleList } from "@/api/system/role";
export default {
  name: "systemUser",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "" && !this.userForm.id) {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      search: {
        searchName: "",
        pageIndex: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      isAdd: true,
      userForm: {
        password: "",
        realName: "",
        phone: "",
        email: "",
        roleIds: [],
      },
      dialogVisible: false,

      roleList: [],
    };
  },
  mounted() {
    this.getTableData(this.search);
    this.getRoleList();
  },
  methods: {
    // 获取表格数据
    getTableData() {
      userList(this.search).then((res) => {
        if (res.data.isSuccess) {
          this.tableData = res.data.data || [];
          this.total = res.data.total || 0;
        }
      });
    },
    getRoleList() {
      roleList().then((res) => {
        if (res.data.isSuccess) {
          this.roleList = res.data.data || [];
        }
      });
    },
    handleAdd() {
      this.userForm = {
        password: "",
        realName: "",
        phone: "",
        email: "",
      };
      this.isAdd = true;
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.isAdd = false;
      this.userForm = { ...row };
      this.dialogVisible = true;
    },
    async handleClick(row) {
      let message = await this.$message
        .delConfirm(`<p style="font-size:17px">确定删除吗？</p>
        <p style=" color: #7e7b7b;">删除后不可恢复!</p>`);
      if (message) {
        let params = { userid: row.userId };
        userDel(params).then((res) => {
          if (res.data.isSuccess) {
            this.$message.success(res.data.message);
            this.handleSearch();
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
      console.log(row);
    },
    handleSearch() {
      this.search.pageIndex = 1;
      this.getTableData();
    },
    clearSearch() {
      this.search = this.$options.data().search;
      this.getTableData();
    },
    handleSizeChange(val) {
      this.search.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange(val) {
      this.search.pageIndex = val;
      this.getTableData();
    },
    handleClose() {
      this.dialogVisible = false;
    },
    handleConfirm() {
      this.$refs.userForm.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        if (this.isAdd) {
          userAdd(this.userForm).then((res) => {
            if (res.data.isSuccess) {
              this.loading = false;
              this.$message.success(res.data.message);
              this.dialogVisible = false;
              this.getTableData(this.search);
            } else {
              this.loading = false;
              this.$message.error(res.data.message);
            }
          });
        } else {
          userUpdate(this.userForm).then((res) => {
            if (res.data.isSuccess) {
              this.loading = false;
              this.$message.success(res.data.message);
              this.dialogVisible = false;
              this.getTableData(this.search);
            } else {
              this.loading = false;
              this.$message.error(res.data.message);
            }
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.el-dialog__wrapper /deep/ .el-dialog {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
}

.el-dialog__wrapper /deep/ .el-dialog__header {
  border-top-left-radius: 7px !important;
  border-top-right-radius: 7px !important;
  background: #409eff;
  padding: 10px 20px 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__title {
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.el-dialog__wrapper /deep/ .el-dialog__headerbtn {
  top: 10px;
}

.el-dialog__wrapper /deep/ .el-dialog__body {
  padding: 10px 20px;
}

.el-dialog__wrapper /deep/ .el-dialog__close {
  color: #ffffff;
}

.el-dialog__wrapper /deep/ .el-dialog__footer {
  border-top: 1px solid #e8eaec;
  padding: 10px !important;
}

.el-button--primary {
  background: #409eff;
}
</style>
